import { CMS_AVAILABLE_WIDTHS, getBestAvailableWidth, transformToSizedSrc } from './imageWidths.js';
import { resolveCdnUrl } from './resolveCdnUrl.js';

const getDefaultImgUrl = (src: string, requestedWidths: number[] | undefined, targetWidth?: number): string => {
  if (!targetWidth || /^(https?:)/i.test(src) || src.toLowerCase().endsWith('.svg')) {
    return resolveCdnUrl(src);
  }

  const normalizedRequestedWidths = requestedWidths
    ?.map((width) => getBestAvailableWidth(width, CMS_AVAILABLE_WIDTHS))
    .filter((width): width is number => width !== undefined);

  const effectiveWidths =
    normalizedRequestedWidths && normalizedRequestedWidths.length > 0
      ? normalizedRequestedWidths
      : CMS_AVAILABLE_WIDTHS;
  const bestWidth = getBestAvailableWidth(targetWidth, effectiveWidths);

  if (!bestWidth) {
    return resolveCdnUrl(src);
  }

  return resolveCdnUrl(transformToSizedSrc(src, bestWidth) ?? src);
};

export { getDefaultImgUrl };
